import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import { toSimpleUtcDateString } from 'src/utils/format/date';
import s from 'src/components/ResultHistoriesBlock/ResultHistoriesBlock.styles';

const ResultHistoriesBlock = ({ resultHistories }) => {
  const { t } = useTranslation();

  if (!resultHistories || (resultHistories && resultHistories.ResultHistories.length === 0)) {
    return null;
  }

  return (
    <s.ReportReviewBlock>
      {resultHistories && resultHistories.ResultHistories.map(resultHistory => (
        <Fragment key={resultHistory.id}>
          <s.ReportReviewNoteInfoBox>
            <s.ReportReviewNoteBoxNoteInfoLeft>
              <s.ReportReviewNoteBoxNoteInfoLeftIn>{resultHistory.userName}</s.ReportReviewNoteBoxNoteInfoLeftIn>
              <s.ReportReviewNoteBoxNoteInfoLeftIn />
            </s.ReportReviewNoteBoxNoteInfoLeft>

            <s.ReportReviewBlockTimeWrapperDiv />
            <div>
              <s.ReportReviewBlockNoteTimeBox>
                <s.ReportReviewBlockNoteTime>
                  <s.ReportReviewBlockNoteTimeText>
                    {resultHistory.createdAt
                      ? toSimpleUtcDateString(
                        resultHistory.createdAt,
                        'DD-MMM-YYYY hh:mm:ss'
                      )
                      : t('N_A')}
                  </s.ReportReviewBlockNoteTimeText>
                </s.ReportReviewBlockNoteTime>
              </s.ReportReviewBlockNoteTimeBox>
            </div>
          </s.ReportReviewNoteInfoBox>
          <s.ReportReviewCommentText>{JSON.stringify(resultHistory.result)}</s.ReportReviewCommentText>
        </Fragment>
      ))}
    </s.ReportReviewBlock>
  );
};

ResultHistoriesBlock.propTypes = {
  resultHistories: PropTypes.arrayOf(PropTypes.object),
};

export default React.memo(ResultHistoriesBlock);
